export default class CssHelper {
  static deleteEpochChartCategoryColoringCSS(name) {
    let styleSheet = document.styleSheets[1];
    let cssRules = styleSheet.cssRules || styleSheet.rules;

    for (let i = 0; i < cssRules.length; i++) {
      if (cssRules[i].selectorText) {
        if (cssRules[i].selectorText.indexOf(name) > -1) {
          if ("removeRule" in styleSheet) {
            styleSheet.removeRule(i);
          }
          else if ("deleteRule" in styleSheet) {
            styleSheet.deleteRule(i);
          }
          i--;
        }
      }
    }
  };

  static deleteInjectedCSS(fn) {
    let styleSheet = document.styleSheets[1];
    let cssRules = styleSheet.cssRules || styleSheet.rules;

    for (let i = 0; i < cssRules.length; i++) {
      if (cssRules[i].selectorText) {
        if (fn(cssRules[i].selectorText)) {
          if ("removeRule" in styleSheet) {
            styleSheet.removeRule(i);
          }
          else if ("deleteRule" in styleSheet) {
            styleSheet.deleteRule(i);
          }
          i--;
        }
      }
    }
  }

  static addCSSRule(selector, rules, index) {
    let styleSheet = document.styleSheets[1];
    if ("insertRule" in styleSheet) {
      try {
        styleSheet.insertRule(selector + "{" + rules + "}", index);
      } catch (err) {
        // debugger;
        console.log(err);
      }
    }
    else if ("addRule" in styleSheet) {
      styleSheet.addRule(selector, rules, index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/cssHelper.js